module.exports = __webpack_public_path__ + "img/match@2x.5fdab430.png";